<template>
    <div v-if="tallas">
        <label>Talla/as</label>
        <ValidationProvider name="talla" id="talla" rules="required" v-slot="{ errors }">
            <multiselect 
                v-model="data.tallasSelect"
                id="talla"
                placeholder="Talla"
                :class="(errors[0] ? 'is-invalid' : '')"
                label="nombre"
                track-by="id"
                :multiple="true" 
                :options="tallas"
            />
            <span v-if="errors[0]" class="d-block bg-danger text-white mt-1 text-xs" style="padding: 5.5px;">{{ errors[0] }}</span>
        </ValidationProvider>
    </div>
</template>

<script>
    export default {
        props: ['data'],
        data() {
            return {
                tallas: null,
            }
        },
        computed: {
            lista_id() {
                return this.$route.params.lista_id;
            } 
        },
        created() {
            const params = {
                lista_id: this.lista_id,
                filters: {}
            }
            this.$store.dispatch(this.config.getVuexAlias('back.bases.indumentarias.get-tallas'), params).then(res => {
                this.tallas = res.data.tallas;
            });
        }
    }
</script>